<template>
    <main class="main" id="main">
        <div class="top_line">
            <div class="container">
                <h1>Партнерская программа</h1>
            </div>
        </div>
        <!----------Section food cards------------->

        <section class="section s-referal_form"  v-if="auth.user && !auth.users.promocode">
            <div class="container">
                <h1>ПРИСОЕДИНЯЙТЕСЬ К ПАРТНЁРСКОЙ ПРОГРАММЕ!</h1>
                <div class="order_form" style="width: 100%;display: flex;justify-content: center;margin-top: 30px;margin-bottom: 50px;">

                    <div class="input_order">
                        <input type="text" name="" class="order" v-model="code">
                        <div class="placeholder">
                            Промокод
                        </div>
                    </div>

                    <div class="buttons_box">
                        <button class="menu_item_btn referal" @click="saveCode">ЗАРАБОТАТЬ БОНУСЫ</button>
                    </div>
                </div>
            </div>
        </section>
        <section class="section s-earn" v-else-if="auth.user">
            <div class="container">
                <h1>Зарабатывай с нами!</h1>

                <div class="referal_types">
                    <div class="type_box">
                        <div class="type_description">
                            <h2>По ссылке</h2>
                            <p>Все очень просто – приводите новых клиентов
                                на <a href="#">хочу-поесть.рф</a> и получайте 50% нашей
                                прибыли от каждого заказа.Заработать можно
                                разными способами, выбирай один или
                                воспользуйся всеми.Зарегистрируйся на сайте
                                и генерируй свою реферальную ссылку, которую
                                можно отправить друзьям, поделиться в соцсетях
                                или опубликовать на сайте или в блоге. Ты
                                можешь сделать реферальную ссылку на любую
                                страницу сайта <a href="#">хочу-поесть.рф</a></p>
                        </div>

                        <div class="type_share">
                            <div class="copy_box">
                                <div class="copy_info">
                                    <input type="text" class="earn_input" :value="'https://хочу-поесть.рф/promocode/' + auth.users.promocode" readonly>
                                </div>
                                <button class="copy"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/referals/copy.svg" alt=""></button>
                            </div>
                        </div>

                    </div>

                    <div class="type_box">
                        <div class="type_description">
                            <h2>По промо-коду</h2>
                            <p>Зарегистрируйте свой личный промокод,
                                который вы можете разместить не только в
                                интернете, но и на любом офф-лайн носителе.</p>
                        </div>
                        <div class="type_share">
                            <div class="copy_box">
                              <div class="copy_info promo">
                                <input type="text" class="earn_input" :value="auth.users.promocode" readonly>
                              </div>
                                <button class="copy"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/referals/copy.svg" alt=""></button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section s-earn" v-else>
            <div class="container">
                <h1>Зарабатывай с нами!</h1>

                <div class="referal_types">
                    <div class="type_box">
                        <h2>По ссылке</h2>
                        <p>Все очень просто – приводите новых клиентов
                            на <a href="#">хочу-поесть.рф</a> и получайте 50% нашей
                            прибыли от каждого заказа.Заработать можно
                            разными способами, выбирай один или
                            воспользуйся всеми.Зарегистрируйся на сайте
                            и генерируй свою реферальную ссылку, которую
                            можно отправить друзьям, поделиться в соцсетях
                            или опубликовать на сайте или в блоге. Ты
                            можешь сделать реферальную ссылку на любую
                            страницу сайта <a href="#">хочу-поесть.рф</a></p>
                    </div>

                    <div class="type_box">
                        <h2>По промо-коду</h2>
                        <p>Зарегистрируйте свой личный промокод,
                            который вы можете разместить не только в
                            интернете, но и на любом офф-лайн носителе.</p>
                    </div>
                </div>
            </div>
        </section>

        <section class="section s-table_partners" v-if="auth.user">
            <div class="container">
                <h1>Лучшие партнёры месяца</h1>

                <div class="table_box">

                    <table class="table_content">

                        <tr class="table_row active">
                            <th>Логин</th>
                            <th>Доход</th>
                            <th>Заработано</th>
                        </tr>

                        <tr class="table_row">
                            <td class="link">login@domail.com</td>
                            <td class="order">+2 заказов</td>
                            <td class="price">500 руб</td>
                        </tr>

                        <tr class="table_row">
                            <td class="link">user@mail.com</td>
                            <td class="order">+3 заказов</td>
                            <td class="price">600 руб</td>
                        </tr>

                        <tr class="table_row">
                            <td class="link">person@domail.com</td>
                            <td class="order">+4 заказов</td>
                            <td class="price">700 руб</td>
                        </tr>
                    </table>

                    <button type="button" class="menu_item_btn add">
                        Показать еще
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_list/add_more.svg" alt="">
                    </button>
                </div>
            </div>
        </section>
        <section class="section s-referal_description">
            <div class="container">
              <div class="tendency_item">
                <center><iframe width="560" height="315" src="https://www.youtube.com/embed/sO_W6GKRFpc" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></center>
              </div>
                <div class="rules">
                    <h1>ПРАВИЛА ПАРТНЁРСКОЙ ПРОГРАММЫ</h1>
                    <p>Принимать участие в партнерской программе может
                        любой зарегистрированный и подтвердивший свой email
                        пользователь сайта <a href="#">www.хочу-поесть.рф</a></p>
                    <p>Каждый зарегистрированный пользователь получает на телефон
                        личный доступ в партнерский аккаунт, где видит всю статистику
                        по проведенным заказам и начислениям;</p>
                    <p>Для приглашения пользователей, необходимо использовать ссылку,
                        баннеры и промо-коды, сформированные с данной партнерской
                        программе;</p>
                    <p>Вознаграждение начисляется с заказа каждого
                        активного партнера и начисляется автоматически;</p>
                    <p>Вознаграждение рассчитывается с суммы, получаемой
                        сервисом <a href="#">www.хочу-поесть.рф</a> от ресторанов;</p>
                    <p>Партнерская программа действует 2 года с момента приглашения
                        пользователя;</p>

                    <p>Все полученные в рамках партнерской программы
                        средства учитываются на балансе пользователя и могут быть
                        выведены по заявке пользователя на карту или электронные
                        кошельки WebMoney или QIWI;</p>

                    <p>Администрация сайта <a href="#">www.хочу-поесть.рф</a> вправе внести
                        изменения в правила партнерской программы, опубликовав изменения;</p>

                    <p>Пользователь, участвующий в партнерской программе, обязуется не
                        размещать партнерскую ссылку в скрытом виде, включая, но не
                        ограничиваясь такими способами ее размещения как: невидимый или
                        плохо видимый фрейм, автоматический редирект без перехода по ссылке,
                        CAP и т.п. Обязуется не размещать некачественные ссылки на сайт
                        <a href="#">www.хочу-поесть.рф</a> не привлекать на сайт некачественный трафик,
                        ботов и т.п. Не использовать агрессивные виды рекламы: попандеры, кликандеры
                        и проч. Не размещать контекстную рекламу по брендовым запросам.
                        Не задействовать для привлечения пользователей несанкционированные
                        рассылки или спам, тем более от лица <a href="#">www.хочу-поесть.рф</a>. И не
                        задействовать любые иные способы, которые могут ввести пользователей
                        в заблуждение и нанести ущерб имиджу сервиса <a href="#">www.хочу-поесть.рф</a>
                        или спровоцировать санкции к www.хочу-поеcть.рф со стороны поисковых системПартнерская программа действует 2 года с момента приглашения
                        пользователя;</p>

                </div>

                <div class="work_explanation">
                    <h1>КАК ЭТО РАБОТАЕТ?</h1>

                    <p>Генерируете рекламный баннер,
                        где располагается ваш личный промо-код или
                        реферальную ссылку;</p>
                    <p>Вы размещаете промо-код или реферальную
                        ссылку на своем любом ресурсе;</p>
                    <p>все, кто прошёл и зарегистрировался на сайте <a href="#">www.хочу-поесть.рф</a>
                        по вашей ссылке и промо-коду, привязываются к Вашему личному
                        кабинету. В конце месяца Вы получаете 50% от прибыли, которую
                        принесли Ваши клиенты, «ХОЧУ-ПОЕСТЬ». Количество человек и сумма
                        потенциальной выплаты отслеживается в Личном кабинете; Вам надоел
                        наш баннер или ссылка? Сделайте новый или снимите его с размещения
                        – мы все равно будем платить Вам 50% от прибыли, которую приносят
                        Ваши клиенты сервису доставки еды «ХОЧУ-ПОЕСТЬ». Потолка выплат
                        нет, сколько бы не пришло людей по вашей ссылке или промо-коду,
                        вы все равно будете получать 50% от прибыли хочу-поесть.рф в
                        течении 2-х лет; Простой пример расчета: при условном среднем
                        чеке заказа в 1200 руб . мы получаем 130-150 руб ., что составляет
                        наши 10-15%, наш партнер соответственно получает из одного заказа
                        75 рублей . Итого, сколько пассивного дохода получите Вы, знаете
                        только вы сами, так как только вам известен реальный охват вашей
                        аудитории. К тому вы сами решаете сколько раз разметить нашу рекламу
                        у себя. Нам отдел маркетинга постарается сделать ее максимально
                        адаптивной для вашей ЦА;</p>
                </div>
            </div>
        </section>

        <section class="section s-referal_form"  v-if="!auth.user">
            <div class="container">
                <h1>ПРИСОЕДИНЯЙТЕСЬ К ПАРТНЁРСКОЙ ПРОГРАММЕ!</h1>
                <div class="order_form">

                    <div class="input_order">
                        <input type="text" name="" class="order" required v-model="name">
                        <div class="placeholder">
                            Ваше имя<span>*</span>
                        </div>
                    </div>

                    <div class="input_order">
                        <input type="text" name="" class="order" required v-model="lastname">
                        <div class="placeholder">
                            Ваша фамилия  <span>*</span>
                        </div>
                    </div>

                    <div class="input_order">
                        <input type="text" name="" class="order" required v-model="city.name">
                        <div class="placeholder">
                            Город <span>*</span>
                        </div>
                    </div>

                    <div class="input_order">
                        <input type="text" name="" class="order" required v-model="email" >
                        <div class="placeholder">
                            user@domain.com <span>*</span>
                        </div>
                    </div>

                    <div class="input_order">
                        <input type="password" name="" class="order" required v-model="password">
                        <div class="placeholder">
                            пароль <span>*</span>
                        </div>
                    </div>

                    <div class="input_order">
                        <input type="password" name="" class="order" required v-model="password2">
                        <div class="placeholder">
                            повторите пароль  <span>*</span>
                        </div>
                    </div>

                    <div class="input_order">
                        <input type="text" name="" class="order" required v-model="phone" data-inputmask="'mask': '+9(999)999-99-99'">
                        <div class="placeholder">
                            +7(__)___ __ __<span>*</span>
                        </div>
                    </div>

                    <div class="input_order">
                        <select class="select_info" name="amount">
                            <option value="">Система для оплаты</option>
                            <option value="1">Visa</option>
                            <option value="2">Yandex</option>
                        </select>
                    </div>

                    <div class="input_order">
                        <input type="text" name="" class="order" required v-model="pay">
                        <div class="placeholder">
                            Номер счета
                        </div>
                    </div>

                    <div class="info_agreement">
                        <input type="checkbox" name="" id="post" v-model="checkbox">
                        <label for="post" id="info_label"></label>
                        <label for="post" @click="checkbox = !checkbox">Я принимаю<a href="#"> условия пользовательского соглашения</a></label>

                    </div>

                    <div class="buttons_box">
                        <button id="order_button" class="menu_item_btn referal" @click="sendReg">ЗАРАБОТАТЬ БОНУСЫ</button>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
import axios from '@/router/http'
import Inputmask from 'inputmask'
export default {
  name: 'partners',
  props: ['city', 'auth', 'basket', 'geo'],
  data () {
    return {
      code: null,
      name: null,
      lastname: null,
      email: null,
      password: null,
      password2: null,
      phone: null,
      payType: null,
      pay: null,
      checkbox: null
    }
  },
  created () {
    Inputmask().remove(document.getElementById('input'))
    setTimeout(() => { Inputmask().mask(document.querySelectorAll('input')) }, 500)
  },
  methods: {
    sendReg () {
      if (!this.email && !this.phone) alert('Вам необходимо заполнить email или телефон')
      else if (!this.password) alert('Вы не ввели пароль')
      else if (this.password !== this.password2) alert('Введенные пароли не совпадают')
      else if (!this.checkbox) alert('Вам необходимо принять согласие на обработку персональных данных')
      else {
        var formData = new FormData()
        formData.append('email', this.email)
        formData.append('phone', this.phone)
        formData.append('name', this.name)
        formData.append('lastname', this.lastname)
        formData.append('password', this.password)
        formData.append('promo', this.promo)
        formData.append('payType', this.payType)
        formData.append('pay', this.pay)
        formData.append('bonus', '200')
        formData.append('city', this.city.id)
        formData.append('uid', this.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/reg-mobile-app',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          if (response.data.title === 'Ошибка') alert(response.data.text)
          else {
            this.auth = response.data
            window.location.href = '/affiliate'
          }
        })
      }
    },
    saveCode () {
      if (!this.code) alert('Вам необходимо указать промокод')
      else {
        var formData = new FormData()
        formData.append('promocode', this.code)
        formData.append('uid', this.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/put-mobile',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          if (response.data.error) alert(response.data.error)
          else {
            this.$root.auth = response.data
            this.$root.user = response.data.users
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/partners.vue